import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';

export const QnaCard = ({ title, label, labelColor = 'default', actions, children }) => (
  <Stack
    gap={1.5}
    p={2.5}
    border="1px solid"
    borderColor="grey.200"
    borderRadius={2}
    bgcolor="background.paper"
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
      <Typography variant="h6" fontWeight={700}>
        {title}
      </Typography>
      {actions ??
        (label && <Chip size="small" label={label} color={labelColor} variant="outlined" />)}
    </Stack>
    {children}
  </Stack>
);

export const QnaEntry = ({ heading, author, text }) => (
  <Stack gap={0.5}>
    <Typography variant="caption" fontWeight={700} color="text.secondary">
      {heading}
      {author ? ` (${author})` : ''}
    </Typography>
    {text && (
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {text}
      </Typography>
    )}
  </Stack>
);

export const QnaEmpty = ({ title, message }) => (
  <Stack alignItems="center" justifyContent="center" gap={1} py={8}>
    <Typography variant="h5" fontWeight={700}>
      {title}
    </Typography>
    <Typography color="text.secondary">{message}</Typography>
  </Stack>
);

export const visibilityLabels = { public: 'Public', limited: 'Limited' };
